<ms-update-user [(user)]="user"></ms-update-user>

<ms-user-membership-list [memberships]="organizationMemberships()"></ms-user-membership-list>